<template>
	<div class="o-page-login" data-component="register"
        :data-component-name="$options.name"
	>
		<div class="o-row">
			<div class="o-col -login-welcome">
				<div class="o-page-login__content">
					<div class="o-page-login__header">
						<SvgIcon name="logo" class="o-page-login__logo" />
					</div>
					<!-- <div class="o-page-login__sub-header">
										Console d'affectation
									</div> -->
					<h1 class="o-page-login__title">
						Gestionnaire <br>haute performance <br>des <strong>affectations</strong>
					</h1>
					<p class="o-page-login__text">
						Optimisez et gérez efficacement les ressources humaines et matérielles nécessaires à la
						réalisation de vos projets grâce à cette application web. Connectez-vous pour accéder à votre
						gestionnaire ou <a href="mailto:info@monriff.ca?subject=Demande d'informations">contactez-nous</a> afin d’en
						savoir plus.
					</p>
					<a href="https://monriff.ca" target="_blank" class="o-button -outline -ico-right o-page-login__button">En savoir
						plus
						<SvgIcon name="external-link" />
					</a>
				</div>
			</div>
			<div class="o-col -login">
				<div class="o-page-connect">
					<h2 class="o-page-connect__title">Création d'un compte</h2>
					<form @submit.prevent="registerUser">
						<div class="o-form__item o-page-connect__input">
							<Input
								label="Nom"
								v-model="form.name"
								prepend-icon="mdi-account"
								type="text"
								placeholder="nom"
							/>
						</div>
						<div class="o-form__item o-page-connect__input">
							<Input
								label="Courriel"
								v-model="form.email"
								prepend-icon="mdi-email"
								type="email"
								placeholder="email"
							/>
						</div>
						<div class="o-form__item o-page-connect__input">
							<Input
								label="Mot de passe"
								v-model="form.password"
								prepend-icon="mdi-lock"
								type="password"
								placeholder="password"
							/>
						</div>
						<div class="o-form__item o-page-connect__input">
							<Input
								label="Confirmer votre mot de passe"
								v-model="form.password_confirmation"
								prepend-icon="mdi-lock"
								type="password"
								placeholder="confirm password"
							/>
						</div>
					</form>
					<div class="o-page-connect__submit">
						<div class="o-page-connect__button -centered">
							<button class="o-button -ico-right" :loading="loading" @click="registerUser" color="primary">S'enregistrer<SvgIcon name="arrow-right" /></button>
						</div>
					</div>
					<div class="o-page-connect__createaccount">
						Vous avez un compte? <router-link :to="{ name: 'login' }">Connexion</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            loading: false,
            form: {
                name: null,
                email: null,
                password: null,
                password_confirmation: null
            }
        }
    },

    methods: {
        ...mapActions({ 'register': 'auth/register' }),
        registerUser() {
            this.loading = true
            this.register(this.form)
                .then(() => {
                    this.$router.push('/login')
                    this.$q.notify({type: 'positive', message: "Votre compte est enregistré"})
                })
                .catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
